// import SwiperCore, {
//   Scrollbar,
//   Navigation,
//   Swiper,
//   Autoplay,
//   Pagination,
// } from '../../node_modules/swiper/core/';
// SwiperCore.use([Scrollbar, Navigation, Autoplay, Pagination]);

import SwiperCore, {
  Scrollbar,
  Navigation,
  Autoplay,
  Pagination,
  Swiper,
} from 'swiper';
SwiperCore.use([Scrollbar, Navigation, Autoplay, Pagination]);

export const carousels = () => {
  const items = document.querySelectorAll('[data-slider]');
  if (items.length <= 0) return;
  items.forEach((item) => {
    const itemId = item.dataset.slider;
    new Swiper(`[data-slider="${itemId}"]`, {
      slidesPerView: 1,
      spaceBetween: 16,
      observer: true,
      observeParents: true,
      scrollbar: {
        el: `[data-scrollbar="${itemId}"]`,
        dragSize: 'auto',
        hide: !1,
        draggable: true,
        snapOnRelease: !0,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag',
      },
      navigation: {
        nextEl: `[data-arrow-next="${itemId}"]`,
        prevEl: `[data-arrow-prev="${itemId}"]`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      autoplay: {
        delay: 5000,
      },
      centeredSlides: true,
      loop: true,
      autoHeight: true,
    });
  });
};
